// Guarda o projeto clicado em memória (não em history.state/pushState) pra
// levar pra /detalhes. O Firefox tem um limite bem mais apertado que outros
// navegadores pro tamanho do state que dá pra passar via history.pushState
// (o que o React Router usa por baixo dos panos) — e o state aqui carrega as
// imagens já decriptadas em base64, que facilmente passam desse limite em
// projetos com várias imagens grandes (Takeda, "Todo Dia Verão", etc.),
// fazendo a navegação falhar silenciosamente só no Firefox. Uma variável em
// memória não tem esse limite, já que a navegação é client-side, na mesma
// aba/mesmo processo JS.
let current = null

export const setSelectedProject = (project) => {
    current = project
}

export const getSelectedProject = () => current
